(function () {
  var STORAGE_KEY = 'oo-juo-subscription-state';

  function parseWeeks(value) {
    if (value === '' || value == null) return null;
    var weeks = parseInt(String(value).trim(), 10);
    if (isNaN(weeks)) return null;
    return weeks;
  }

  function normalizeWeeks(value, fallback) {
    var weeks = parseWeeks(value);
    if (weeks === null) return fallback;
    if (weeks < 1) return 1;
    if (weeks > 8) return 8;
    return weeks;
  }

  function readState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeState(state) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      /* ignore quota / privacy mode */
    }
  }

  function initJuoSubscription(root) {
    if (!root) return;
    var isFirstInit = root.dataset.juoInitialized !== 'true';
    if (isFirstInit) {
    root.dataset.juoInitialized = 'true';

    var purchaseCards = root.querySelectorAll('[data-juo-purchase-type]');
    var groupInputs = root.querySelectorAll('input[name="selling_plan_group"]');
    var frequencyButtons = root.querySelectorAll('[data-juo-frequency]');
    var customFrequency = root.querySelector('[data-juo-custom-frequency]');
    var weeksInput = root.querySelector('[data-juo-weeks-input]');
    var upsellOptions = root.querySelectorAll('[data-juo-upsell-option]');
    var variantLinks = root.querySelectorAll('a.oo-variant-btn');
    var cartForms = Array.from(document.querySelectorAll('form[action$="/cart/add"]'));

    if (weeksInput && !root.dataset.juoCustomWeeks) {
      root.dataset.juoCustomWeeks = weeksInput.value || '4';
    }

    function getWeeksFallback() {
      return parseWeeks(root.dataset.juoCustomWeeks) || parseWeeks(weeksInput && weeksInput.value) || 4;
    }

    function getPlanInputs() {
      return root.querySelectorAll(
        'input[name="selling_plan"], input[xname="selling_plan"], input[data-juo-plan-weeks]'
      );
    }

    function ensureCartFormPlanInputs() {
      cartForms = Array.from(document.querySelectorAll('form[action$="/cart/add"]'));
      cartForms.forEach(function (form) {
        var input = form.querySelector('input[name="selling_plan"], input[data-juo-form-selling-plan]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          input.setAttribute('data-juo-form-selling-plan', 'true');
          form.appendChild(input);
        }
      });
    }

    function updateSellingPlanId(planId) {
      ensureCartFormPlanInputs();
      var value = planId ? String(planId) : '';
      cartForms.forEach(function (form) {
        var input = form.querySelector('input[name="selling_plan"], input[data-juo-form-selling-plan]');
        if (input) input.value = value;
      });
    }

    function disableSellingPlans() {
      getPlanInputs().forEach(function (planInput) {
        planInput.checked = false;
        planInput.removeAttribute('required');
        planInput.setAttribute('type', 'hidden');
        if (planInput.getAttribute('name') === 'selling_plan') {
          planInput.setAttribute('xname', 'selling_plan');
          planInput.removeAttribute('name');
        }
        planInput.disabled = true;
      });
      updateSellingPlanId('');
    }

    function enableSellingPlans() {
      getPlanInputs().forEach(function (planInput) {
        planInput.disabled = false;
        planInput.setAttribute('type', 'radio');
        if (planInput.getAttribute('xname') === 'selling_plan') {
          planInput.setAttribute('name', 'selling_plan');
          planInput.removeAttribute('xname');
        } else if (!planInput.getAttribute('name')) {
          planInput.setAttribute('name', 'selling_plan');
        }
        // Theme sellingplans handler may set required with none checked.
        planInput.removeAttribute('required');
      });
    }

    function selectPlanByWeeks(weeks) {
      var normalized = normalizeWeeks(weeks, getWeeksFallback());
      var targetWeeks = String(normalized);
      var matched = false;
      var matchedInput = null;

      getPlanInputs().forEach(function (planInput) {
        if (planInput.dataset.juoPlanWeeks === targetWeeks) {
          matchedInput = planInput;
          matched = true;
        } else {
          planInput.checked = false;
        }
      });

      if (matchedInput) {
        if (matchedInput.getAttribute('xname') === 'selling_plan') {
          matchedInput.setAttribute('name', 'selling_plan');
          matchedInput.removeAttribute('xname');
        }
        matchedInput.disabled = false;
        matchedInput.setAttribute('type', 'radio');
        matchedInput.checked = true;
        matchedInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateSellingPlanId(matchedInput.value);
      }

      root.dataset.juoCustomWeeks = targetWeeks;
      return matched;
    }

    function selectActiveFrequencyPlan() {
      enableSellingPlans();

      var activePreset = root.querySelector('[data-juo-frequency="preset"].is-active');
      var customButton = root.querySelector('[data-juo-frequency="custom"].is-active');

      if (customButton || isCustomFrequencyActive()) {
        selectPlanByWeeks(getWeeksFallback());
        return;
      }

      if (activePreset) {
        if (activePreset.dataset.juoPlanId) {
          var matched = false;
          getPlanInputs().forEach(function (planInput) {
            if (planInput.value === activePreset.dataset.juoPlanId) {
              planInput.checked = true;
              planInput.dispatchEvent(new Event('change', { bubbles: true }));
              updateSellingPlanId(planInput.value);
              matched = true;
            } else {
              planInput.checked = false;
            }
          });
          if (matched) return;
        }
        if (activePreset.dataset.juoWeeks) {
          selectPlanByWeeks(activePreset.dataset.juoWeeks);
          return;
        }
      }

      selectPlanByWeeks(getWeeksFallback());
    }

    function ensureSubscriptionPlans() {
      enableSellingPlans();
      selectActiveFrequencyPlan();
      getPlanInputs().forEach(function (planInput) {
        planInput.removeAttribute('required');
      });
    }

    function setActiveFrequencyButton(button) {
      frequencyButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn === button);
      });
    }

    function setPurchaseType(type) {
      var isSubscription = type === 'subscription';
      root.classList.toggle('is-subscription', isSubscription);
      purchaseCards.forEach(function (card) {
        card.classList.toggle('is-active', card.dataset.juoPurchaseType === type);
      });
      syncQuantityPerDiaper(type);

      var formId = root.dataset.juoFormId;
      if (formId) {
        var form = document.getElementById(formId);
        if (form) form.classList.toggle('is-juo-subscription', isSubscription);
      }

      var sticky = document.getElementById('sticky-add-to-cart');
      if (sticky) sticky.classList.toggle('is-juo-subscription', isSubscription);

      // Theme sellingplans handler runs on the same change and clears checked plans.
      if (isSubscription) {
        ensureSubscriptionPlans();
        window.setTimeout(ensureSubscriptionPlans, 0);
      } else {
        disableSellingPlans();
        window.setTimeout(disableSellingPlans, 0);
      }
    }

    function syncQuantityPerDiaper(type) {
      var isSubscription = type === 'subscription';
      root.querySelectorAll('[data-juo-per-diaper]').forEach(function (el) {
        var onetimeValue = el.dataset.onetimePerDiaper;
        var subscriptionValue = el.dataset.subscriptionPerDiaper;
        var label = el.dataset.perDiaperLabel || '';
        var value = isSubscription && subscriptionValue ? subscriptionValue : onetimeValue;
        if (value) {
          el.textContent = label ? value + ' ' + label : value;
        }
      });
    }

    function syncFromGroupInput(input) {
      if (!input.checked) return;
      var isOneTime = input.id && input.id.indexOf('purchase_option_single') === 0;
      setPurchaseType(isOneTime ? 'one-time' : 'subscription');
    }

    function isCustomFrequencyActive() {
      var customButton = root.querySelector('[data-juo-frequency="custom"]');
      return customButton && customButton.classList.contains('is-active');
    }

    function commitWeeksInput() {
      if (!weeksInput) return;
      var normalized = normalizeWeeks(weeksInput.value, getWeeksFallback());
      weeksInput.value = String(normalized);
      root.dataset.juoCustomWeeks = String(normalized);
      if (isCustomFrequencyActive()) {
        selectPlanByWeeks(normalized);
      }
      persistState();
    }

    function persistState() {
      var subscriptionCard = root.querySelector('[data-juo-purchase-type="subscription"]');
      var oneTimeCard = root.querySelector('[data-juo-purchase-type="one-time"]');
      var subscriptionInput = subscriptionCard && subscriptionCard.querySelector('input[name="selling_plan_group"]');
      var oneTimeInput = oneTimeCard && oneTimeCard.querySelector('input[name="selling_plan_group"]');
      var purchaseType = 'subscription';

      if (oneTimeInput && oneTimeInput.checked) {
        purchaseType = 'one-time';
      } else if (subscriptionInput && subscriptionInput.checked) {
        purchaseType = 'subscription';
      } else if (root.classList.contains('is-subscription')) {
        purchaseType = 'subscription';
      } else if (oneTimeCard) {
        purchaseType = 'one-time';
      }

      var state = { purchaseType: purchaseType };

      if (purchaseType === 'subscription') {
        var weeks = getWeeksFallback();
        var activePreset = root.querySelector('[data-juo-frequency="preset"].is-active');

        if (isCustomFrequencyActive()) {
          state.frequencyType = 'custom';
          state.weeks = String(weeks);
        } else if (activePreset && activePreset.dataset.juoWeeks) {
          state.frequencyType = 'preset';
          state.weeks = activePreset.dataset.juoWeeks;
        } else {
          var checkedPlan = root.querySelector('input[name="selling_plan"]:checked');
          if (checkedPlan && checkedPlan.dataset.juoPlanWeeks) {
            var planWeeks = checkedPlan.dataset.juoPlanWeeks;
            state.frequencyType = planWeeks === '2' || planWeeks === '4' || planWeeks === '8' ? 'preset' : 'custom';
            state.weeks = planWeeks;
          }
        }

        var upsellChoice = root.querySelector('[data-juo-upsell] input[name^="juo-upsell-"]:checked');
        if (upsellChoice) {
          state.upsellMode = upsellChoice.value;
        }
      }

      writeState(state);
    }

    function applyFrequencyState(state) {
      if (!state || !state.weeks) return;

      var weeks = normalizeWeeks(state.weeks, 4);
      var presetButton = root.querySelector('[data-juo-frequency="preset"][data-juo-weeks="' + weeks + '"]');

      if (state.frequencyType === 'preset' && presetButton) {
        setActiveFrequencyButton(presetButton);
        if (customFrequency) {
          customFrequency.classList.remove('is-visible');
        }
        if (presetButton.dataset.juoPlanId) {
          getPlanInputs().forEach(function (planInput) {
            if (planInput.value === presetButton.dataset.juoPlanId) {
              planInput.checked = true;
              planInput.dispatchEvent(new Event('change', { bubbles: true }));
              updateSellingPlanId(planInput.value);
            } else {
              planInput.checked = false;
            }
          });
        } else {
          selectPlanByWeeks(weeks);
        }
        root.dataset.juoCustomWeeks = String(weeks);
        return;
      }

      var customButton = root.querySelector('[data-juo-frequency="custom"]');
      if (weeksInput) {
        weeksInput.value = String(weeks);
      }
      root.dataset.juoCustomWeeks = String(weeks);

      if (customButton) {
        setActiveFrequencyButton(customButton);
        if (customFrequency) {
          customFrequency.classList.add('is-visible');
        }
      }

      selectPlanByWeeks(weeks);
    }

    function syncUpsellActiveState() {
      upsellOptions.forEach(function (item) {
        var input = item.querySelector('input[type="checkbox"]');
        item.classList.toggle('is-active', !!(input && input.checked));
      });
    }

    function applyUpsellState(state) {
      if (!state || !state.upsellMode) return;
      var upsellEl = root.querySelector('[data-juo-upsell]');
      if (!upsellEl) return;
      var upsellInput = upsellEl.querySelector('input[value="' + state.upsellMode + '"]');
      if (!upsellInput) return;
      upsellInput.checked = true;
      syncUpsellActiveState();
    }

    function applySavedState(state) {
      if (!state) return false;

      var subscriptionCard = root.querySelector('[data-juo-purchase-type="subscription"]');
      var oneTimeCard = root.querySelector('[data-juo-purchase-type="one-time"]');
      var subscriptionInput = subscriptionCard && subscriptionCard.querySelector('input[name="selling_plan_group"]');
      var oneTimeInput = oneTimeCard && oneTimeCard.querySelector('input[name="selling_plan_group"]');

      if (state.purchaseType === 'one-time' && oneTimeInput) {
        oneTimeInput.checked = true;
        oneTimeInput.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      if (subscriptionInput) {
        subscriptionInput.checked = true;
        subscriptionInput.dispatchEvent(new Event('change', { bubbles: true }));
        applyFrequencyState(state);
        applyUpsellState(state);
        return true;
      }

      return false;
    }

    function applyDefaultFrequencyFromPlan() {
      var checkedPlan = root.querySelector('input[name="selling_plan"]:checked');
      if (!checkedPlan) return;

      var weeks = checkedPlan.dataset.juoPlanWeeks;
      var activeFrequency = null;

      if (weeks === '2' || weeks === '4' || weeks === '8') {
        activeFrequency = root.querySelector('[data-juo-frequency="preset"][data-juo-weeks="' + weeks + '"]');
      } else if (weeks) {
        activeFrequency = root.querySelector('[data-juo-frequency="custom"]');
        if (weeksInput) {
          weeksInput.value = String(normalizeWeeks(weeks, getWeeksFallback()));
          root.dataset.juoCustomWeeks = weeksInput.value;
        }
        if (customFrequency) {
          customFrequency.classList.add('is-visible');
        }
      }

      if (!activeFrequency && checkedPlan.value) {
        activeFrequency = root.querySelector('[data-juo-plan-id="' + checkedPlan.value + '"]');
      }

      if (activeFrequency) {
        setActiveFrequencyButton(activeFrequency);
        if (activeFrequency.dataset.juoFrequency === 'custom' && customFrequency) {
          customFrequency.classList.add('is-visible');
        }
      }
    }

    groupInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        syncFromGroupInput(input);
        persistState();
      });
      syncFromGroupInput(input);
    });

    purchaseCards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-juo-info], [data-juo-info-wrap]')) return;
        var input = card.querySelector('input[name="selling_plan_group"]');
        if (!input) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    frequencyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var planId = button.dataset.juoPlanId;
        var isCustom = button.dataset.juoFrequency === 'custom';

        setActiveFrequencyButton(button);

        if (customFrequency) {
          customFrequency.classList.toggle('is-visible', isCustom);
        }

        if (isCustom) {
          if (weeksInput) {
            if (parseWeeks(weeksInput.value) === null) {
              weeksInput.value = String(getWeeksFallback());
            }
            selectPlanByWeeks(weeksInput.value);
          }
          persistState();
          return;
        }

        if (planId) {
          getPlanInputs().forEach(function (planInput) {
            if (planInput.value === planId) {
              if (planInput.getAttribute('xname') === 'selling_plan') {
                planInput.setAttribute('name', 'selling_plan');
                planInput.removeAttribute('xname');
              }
              planInput.disabled = false;
              planInput.setAttribute('type', 'radio');
              planInput.checked = true;
              planInput.dispatchEvent(new Event('change', { bubbles: true }));
              updateSellingPlanId(planInput.value);
            } else {
              planInput.checked = false;
            }
          });
        } else if (button.dataset.juoWeeks) {
          selectPlanByWeeks(button.dataset.juoWeeks);
        }

        persistState();
      });
    });

    if (weeksInput) {
      weeksInput.addEventListener('input', function () {
        var weeks = parseWeeks(weeksInput.value);

        if (weeks === null) {
          return;
        }

        if (weeks > 8) {
          weeksInput.value = '8';
          weeks = 8;
        }

        root.dataset.juoCustomWeeks = String(weeks);

        if (isCustomFrequencyActive() && weeks >= 1 && weeks <= 8) {
          selectPlanByWeeks(weeks);
          persistState();
        }
      });

      weeksInput.addEventListener('blur', commitWeeksInput);

      weeksInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          weeksInput.blur();
        }
      });
    }

    upsellOptions.forEach(function (option) {
      var input = option.querySelector('input[type="checkbox"]');
      if (!input) return;

      input.addEventListener('change', function () {
        if (input.checked) {
          upsellOptions.forEach(function (other) {
            if (other === option) return;
            var otherInput = other.querySelector('input[type="checkbox"]');
            if (otherInput) otherInput.checked = false;
          });
        }
        syncUpsellActiveState();
        persistState();
      });
    });

    syncUpsellActiveState();

    variantLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        persistState();
      });
    });

    var savedState = readState();
    if (!applySavedState(savedState)) {
      applyDefaultFrequencyFromPlan();
      groupInputs.forEach(function (input) {
        if (input.checked) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    } else {
      persistState();
    }

    // Final sync so one-time never leaves a selling_plan in the form on load
    var checkedGroup = root.querySelector('input[name="selling_plan_group"]:checked');
    if (checkedGroup) {
      syncFromGroupInput(checkedGroup);
    }

    ensureCartFormPlanInputs();
    var checkedPlanOnLoad =
      root.querySelector('input[name="selling_plan"]:checked') ||
      root.querySelector('input[data-juo-plan-weeks]:checked');
    if (root.classList.contains('is-subscription') && checkedPlanOnLoad) {
      updateSellingPlanId(checkedPlanOnLoad.value);
    } else if (!root.classList.contains('is-subscription')) {
      updateSellingPlanId('');
    }

    if (root.classList.contains('is-subscription')) {
      syncQuantityPerDiaper('subscription');
    } else {
      syncQuantityPerDiaper('one-time');
    }

    setupSubscriptionCart(root);
    }
    initInfoTooltips(root);
  }

  function initInfoTooltips(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-juo-info-wrap]').forEach(function (wrap) {
      if (wrap.dataset.juoInfoBound === 'true') return;
      wrap.dataset.juoInfoBound = 'true';

      var btn = wrap.querySelector('[data-juo-info]');
      var tooltip = wrap.querySelector('.oo-juo-subscription__info-tooltip');
      if (!btn || !tooltip) return;

      var placeholder = document.createComment('juo-info-tooltip');
      var isOnBody = false;
      var hideTimer = null;

      function positionTooltip() {
        var rect = btn.getBoundingClientRect();
        var gap = 8;
        tooltip.style.left = rect.left + rect.width / 2 + 'px';
        tooltip.style.top = rect.bottom + gap + 'px';
        tooltip.classList.remove('is-above');
        tooltip.classList.add('is-below');
      }

      function showTooltip() {
        if (hideTimer) {
          clearTimeout(hideTimer);
          hideTimer = null;
        }
        if (!isOnBody) {
          wrap.insertBefore(placeholder, tooltip);
          document.body.appendChild(tooltip);
          isOnBody = true;
        }
        tooltip.classList.add('is-visible', 'is-fixed');
        positionTooltip();
      }

      function hideTooltip() {
        hideTimer = setTimeout(function () {
          tooltip.classList.remove('is-visible');
          if (isOnBody && placeholder.parentNode) {
            placeholder.parentNode.insertBefore(tooltip, placeholder);
            placeholder.remove();
            isOnBody = false;
            tooltip.classList.remove('is-fixed', 'is-above', 'is-below');
            tooltip.style.left = '';
            tooltip.style.top = '';
          }
        }, 80);
      }

      function onScrollOrResize() {
        if (tooltip.classList.contains('is-visible')) {
          positionTooltip();
        }
      }

      btn.addEventListener('pointerenter', showTooltip);
      btn.addEventListener('pointerleave', hideTooltip);
      btn.addEventListener('focus', showTooltip);
      btn.addEventListener('blur', hideTooltip);

      window.addEventListener('scroll', onScrollOrResize, true);
      window.addEventListener('resize', onScrollOrResize);
    });
  }

  function getUpsellPlans(upsellEl) {
    var plansScript = upsellEl.querySelector('[data-juo-upsell-plans]');
    if (!plansScript) return {};
    try {
      return JSON.parse(plansScript.textContent);
    } catch (error) {
      return {};
    }
  }

  function showCartError(message) {
    if (!message) return;
    window.dispatchEvent(
      new CustomEvent('showAlert', {
        detail: { message: message, type: 'error' },
      })
    );
  }

  function updateHeaderCartCount() {
    var qtyEl = document.querySelector('#cart [data-totalqty]');
    var countEl = document.getElementById('cart-count');
    if (countEl && qtyEl) {
      countEl.innerHTML = qtyEl.dataset.totalqty;
    }

    var priceEl = document.querySelector('#cart [data-totalprice]');
    var totalEl = document.getElementById('cart-total');
    if (totalEl && priceEl) {
      totalEl.innerHTML = priceEl.dataset.totalprice;
    }
  }

  function refreshSideCart(sectionHtml, openDrawer) {
    var cart = document.getElementById('cart');
    if (cart && sectionHtml) {
      var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var section = parsed.querySelector('#shopify-section-side-cart');
      if (section) {
        cart.innerHTML = section.innerHTML;
      }
    }

    updateHeaderCartCount();

    window.dispatchEvent(new CustomEvent('listCart'));
    window.dispatchEvent(new CustomEvent('modulePanel'));
    window.dispatchEvent(new CustomEvent('semanticInput'));
    window.dispatchEvent(new CustomEvent('formValidate'));

    if (openDrawer && window.general && window.general.enable_cart_drawer) {
      var cartLink = document.querySelector('a[data-panel="cart"]');
      if (cartLink) {
        cartLink.click();
      }
    }
  }

  function refreshCartAfterUpsellAdd(response) {
    if (response && response.sections && response.sections['side-cart'] && window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load(response, true);
      return;
    }

    refreshSideCart(response && response.sections && response.sections['side-cart'], true);
  }

  function getFormField(form, formId, name) {
    if (form) {
      var inForm = form.querySelector('[name="' + name + '"]');
      if (inForm) return inForm;
    }
    return document.querySelector('[name="' + name + '"][form="' + formId + '"]');
  }

  function isSubscriptionSelected(root, formId) {
    if (root.classList.contains('is-subscription')) return true;
    var subscriptionInput = root.querySelector('[data-juo-purchase-type="subscription"] input[name="selling_plan_group"]');
    if (subscriptionInput && subscriptionInput.checked) return true;
    var linkedSubscriptionInput = document.querySelector(
      '[data-juo-purchase-type="subscription"] input[name="selling_plan_group"][form="' + formId + '"]'
    );
    return !!(linkedSubscriptionInput && linkedSubscriptionInput.checked);
  }

  function getCheckedSellingPlan(root, formId) {
    return (
      root.querySelector('input[name="selling_plan"]:checked') ||
      document.querySelector('input[name="selling_plan"][form="' + formId + '"]:checked')
    );
  }

  function getCartRootUrl() {
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return cartRoot.replace(/\/?$/, '/');
  }

  function fetchCart() {
    return fetch(getCartRootUrl() + 'cart.js', {
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      return response.json();
    });
  }

  function cartHasWelcomeGift(cart, welcomeGiftVariantId) {
    if (!cart || !cart.items || !welcomeGiftVariantId) return false;
    return cart.items.some(function (item) {
      if (parseInt(item.variant_id, 10) === welcomeGiftVariantId) return true;
      var properties = item.properties || {};
      return properties._subscription_welcome_gift === 'true';
    });
  }

  function buildWelcomeGiftItem(welcomeGiftVariantId) {
    return {
      id: welcomeGiftVariantId,
      quantity: 1,
      properties: {
        _subscription_welcome_gift: 'true',
        Welkomstcadeau: 'Gratis sample bij abonnement',
      },
    };
  }

  function postCartAddItems(items) {
    return fetch(getCartRootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: items,
        sections: 'side-cart',
        sections_url: window.location.pathname,
      }),
    }).then(function (response) {
      return response.json();
    });
  }

  function handleSubscriptionCartSubmit(event, root, form, formId, upsellEl, upsellVariantId, upsellPlans) {
    if (!isSubscriptionSelected(root, formId)) return;

    var welcomeGiftVariantId = parseInt(root.dataset.juoWelcomeGiftVariantId, 10) || 0;
    var upsellChoice = upsellEl
      ? upsellEl.querySelector('input[name^="juo-upsell-"]:checked')
      : null;
    var hasUpsell = !!(upsellChoice && upsellVariantId);
    var hasWelcomeGift = welcomeGiftVariantId > 0;

    // One-time path / plain subscription without gift or upsell → theme ajaxCart
    if (!hasUpsell && !hasWelcomeGift) return;

    var mainVariantInput = getFormField(form, formId, 'id');
    if (!mainVariantInput || !mainVariantInput.value) return;

    var quantityInput = getFormField(form, formId, 'quantity');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    var mainPlanInput = getCheckedSellingPlan(root, formId);

    event.preventDefault();
    event.stopImmediatePropagation();

    form.classList.add('processing');
    var sticky = document.getElementById('sticky-add-to-cart');
    if (sticky) sticky.classList.add('processing');

    var items = [
      {
        id: parseInt(mainVariantInput.value, 10),
        quantity: quantity,
      },
    ];

    if (mainPlanInput && mainPlanInput.value) {
      items[0].selling_plan = parseInt(mainPlanInput.value, 10);
    }

    if (hasUpsell) {
      var upsellItem = {
        id: upsellVariantId,
        quantity: 1,
      };

      if (upsellChoice.value === 'subscription' && mainPlanInput && mainPlanInput.dataset.juoPlanWeeks) {
        var upsellPlanId = upsellPlans[mainPlanInput.dataset.juoPlanWeeks];
        if (upsellPlanId) {
          upsellItem.selling_plan = parseInt(upsellPlanId, 10);
        }
      }

      items.push(upsellItem);
    }

    var addGiftPromise = Promise.resolve(false);
    if (hasWelcomeGift) {
      addGiftPromise = fetchCart()
        .then(function (cart) {
          return !cartHasWelcomeGift(cart, welcomeGiftVariantId);
        })
        .catch(function () {
          return true;
        });
    }

    addGiftPromise
      .then(function (shouldAddGift) {
        if (shouldAddGift) {
          items.push(buildWelcomeGiftItem(welcomeGiftVariantId));
        }
        return postCartAddItems(items);
      })
      .then(function (response) {
        form.classList.remove('processing');
        if (sticky) sticky.classList.remove('processing');

        if (response.status) {
          showCartError(response.description || response.message);
          return;
        }

        refreshCartAfterUpsellAdd(response);
      })
      .catch(function () {
        form.classList.remove('processing');
        if (sticky) sticky.classList.remove('processing');
        showCartError(window.translations && window.translations.general_alerts_error_text);
      });
  }

  function setupSubscriptionCart(root) {
    var formId = root.dataset.juoFormId;
    if (!formId) return;

    var form = document.getElementById(formId);
    if (!form || form.dataset.juoSubscriptionCartBound === 'true') return;
    form.dataset.juoSubscriptionCartBound = 'true';

    var upsellEl = root.querySelector('[data-juo-upsell]');
    var upsellVariantId = upsellEl ? parseInt(upsellEl.dataset.juoUpsellVariantId, 10) : 0;
    var upsellPlans = upsellEl ? getUpsellPlans(upsellEl) : {};
    var welcomeGiftVariantId = parseInt(root.dataset.juoWelcomeGiftVariantId, 10) || 0;

    if (!upsellVariantId && !welcomeGiftVariantId) return;

    form.addEventListener(
      'submit',
      function (event) {
        handleSubscriptionCartSubmit(
          event,
          root,
          form,
          formId,
          upsellEl,
          upsellVariantId,
          upsellPlans
        );
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('[data-juo-subscription]').forEach(initJuoSubscription);
    initInfoTooltips(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('sellingplans', initAll);
})();
